import { useState } from "react";
import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { columnsExtraTime } from "../../../../types/columnsTables/columnExtraTime";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import CardProjectFiche from "./CardProjectFiche";


const CardExtraTime = ({ isSuperAdmin, isAdmin, extraTime = [], activeModalDetailsProject, deleteRow }) => {
    const [isLoading, setIsLoading] = useState(false)

    const editForm = (e) => {
        activeModalDetailsProject(typeForDetailsProyect.hrsExtraTime, {
            type: 1,
            title: "Agregar Tiempo Extra",
            dataForm: {
                ...e,
                periodOfWork: e?.periodOfWork ?? "",
                comment: e?.comment ?? "",
                area: e.area,
                email: e.developer,
            },
        });
    }

    const deleteData = async (key) => {
        setIsLoading(true)
        await deleteRow(typeForDetailsProyect.deleteExtraTime, { extraTimeId: key });
        setIsLoading(false)
    }
    const { columns: columnExtraTime, props: propsExtraTime } = columnsExtraTime(
        editForm,
        deleteData,
        { isSuperAdmin: isSuperAdmin }
    );

    return (
        <CardProjectFiche
            title="Horas extras"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.hrsExtraTime, {
                            type: 0,
                            title: "Agregar Tiempo Extra",
                        });
                    }}
                    className="h-full w-[15px] cursor-pointer"
                >
                    <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                </div>
            }
        >
            <div className="w-full">
                <TableGeneral
                    loading={isLoading}
                    column={columnExtraTime}
                    state={extraTime}
                    pagination={{ position: ["topLeft", "topLeft"], pageSize: 5 }}
                    tableProps={propsExtraTime}
                />
            </div>
        </CardProjectFiche>
    );
};

export default CardExtraTime;
